import Javascript from "../../../static/assets/svg/javascript.svg"
import React from "../../../static/assets/svg/react.svg"
import Vuejs from "../../../static/assets/svg/vue.svg"
import Nodejs from "../../../static/assets/svg/nodejs.svg"
import Html from "../../../static/assets/svg/html.svg"
import Css from "../../../static/assets/svg/css.svg"
import Postgresql from "../../../static/assets/svg/postgresql.svg"
import Mongodb from "../../../static/assets/svg/mongodb.svg"
import Git from "../../../static/assets/svg/git.svg"
// import Java from "../../../static/assets/svg/Java.svg"

const Icons = {
  Javascript,
  React,
  Vuejs,
  Nodejs,
  Html,
  Css,
  Postgresql,
  Mongodb,
  Git,
  // Java,
}

export default Icons
